import { render } from "./ForgottenPasswordForm.vue?vue&type=template&id=3c8faf0a&scoped=true"
import script from "./ForgottenPasswordForm.vue?vue&type=script&lang=js"
export * from "./ForgottenPasswordForm.vue?vue&type=script&lang=js"

import "./ForgottenPasswordForm.vue?vue&type=style&index=0&id=3c8faf0a&scoped=true&lang=css"
import "./ForgottenPasswordForm.vue?vue&type=style&index=1&id=3c8faf0a&lang=css"

import exportComponent from "../../../../../Users/matteocoffin/Documents/ecommerce-ouicsport copie 4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c8faf0a"]])

export default __exports__